<template>
	<div class="order-item">
		<div class="order-title">
			<div class="title">
				<span>业务流水号：{{ item.refund_no }}</span>
				<span>关联订单号：{{ item.order.order_no }}</span>
				<span>申请时间：{{ item.apply_time }}</span>
			</div>
			<div class="delete"></div>
		</div>
		<div class="order-content" @click="toDetail2">

			<div class="img-box border-right" >
				<div class="flex">
					<img :src="item.order.design_mtm.design_data.effect_picture" />
					<div class="name">{{ item.order.design_mtm.design_data.category.category_name_cn }}</div>
				</div>
			</div>
			<div class="detail-box border-right">
				<div class="">
					<div>{{ item.order.design_mtm.design_key }}</div>
					<div>数量：{{item.order.design_mtm.quantity}}</div>
					<div>单价：￥{{ item.order.design_mtm.price }}</div>
				</div>
			</div>

			<div class="price-box border-right">
				<div class="price">￥{{item.order.total}}</div>
			</div>
			<div class="status-box border-right">
				<div class="status">{{ item.status | refundStatusName }}</div>
				<div class="detail" @click="toDetail">订单详情</div>
				<!-- <div class="detail">查看物流</div> -->
			</div>
			<div class="action-box">

				<div class="action" v-if="[1].includes(item.status)" @click.stop="go2fill">填写物流</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { cancelOrder, confirmOrder } from "@/api"
	export default {
		name: 'RefundItem',
		props: {
			item: Object,
		},
		data() {
			return {

			};
		},
		computed:{

		},
		methods: {
			toDetail() {
				this.$router.push({
					path: "orderdetail",
					query: {order_id : this.item.order.order_id}
				});
			},
			go2fill() {
				this.$router.push({
					name: "Fixing",
					query: {id : this.item.id}
				});
			}
		}
	}
</script>

<style scoped lang="scss">
	.order-item {
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		margin-bottom: 10px;

		.order-title {
			height: 40px;
			background: #F5F5F5;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;

			.title {
				color: #333333;
				font-size: 14px;

				span {
					margin-right: 40px;
				}
			}
		}

		.order-content {
			width: 100%;
			height: auto;
			display: flex;

			.img-box {
				width: 450px;
				height: auto;

				display: flex;
				padding: 20px;

				img {
					width: 100px;
					height: 100px;
					margin-right: 20px;
				}

				.name {
					font-size: 15px;
					font-family: PingFang SC;
					font-weight: bold;
					width: 288px;
					color: #333333;
					margin-top: 29px;
				}
			}

			.detail-box {
				width: 133px;
				height: auto;
				padding: 11px;
				font-size: 12px;
				font-weight: 400;
				color: #666;

				div {
					margin-top: 10px;
				}
			}

			.price-box {
				width: 130px;
				text-align: center;
				font-size: 12px;
				font-weight: 400;
				color: #666666;

				.price {
					margin-top: 46px;
					margin-bottom: 10px;
					font-size: 15px;
					font-weight: 600;
					color: #0F114A;
				}
			}

			.status-box {
				width: 88px;
				text-align: center;

				.status {
					margin-top: 30px;
					font-size: 14px;
					font-weight: bold;
					color: #BE0505;
				}

				.detail {
					font-size: 14px;
					font-weight: 400;
					color: #666666;
					margin-top: 10px;
					cursor: pointer;
				}
			}

			.action-box {
				width: 112px;
				font-size: 13px;
				text-align: center;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				.action {
					margin: 0 auto;
					width: 72px;
					height: 24px;
					line-height: 24px;
					background: #0F114A;
					border-radius: 3px;
					text-align: center;
					color: #EDD4AC;
					margin-top: 10px;
					cursor: pointer;
				}

				.action-cancel {
					margin: 0 auto;
					width: 72px;
					height: 24px;
					line-height: 24px;
					background: #FFFFFF;
					border-radius: 3px;
					text-align: center;
					color: #0F114A;
					margin-top: 10px;
					border: 1px solid #0F114A;

				}
			}


		}

		.border-right {
			border-right: 1px solid #EEEEEE;
		}
	}
	.flex{
		display: flex;
	}
	.consignee-box{
		padding: 10px 24px;
		font-size: 14px;
		border-top: 1px solid #EEEEEE;
		span{
			margin-right: 10px;
		}
	}
</style>
